<template>
    <div>
        <Main title="Taxonomies" subtitle="Company Taxonomies">
            <template v-slot:table>
                <v-app>
                    <div class="row mb-1 justify-content-between">
                        <div class="col-md-4 align-self-center">
                            <div class="input-group">
                                <v-text-field
                                    v-model="searchData.q"
                                    clearable
                                    clear-icon="mdi-close"
                                    type="text"
                                    placeholder="Search by Brand Name"
                                >
                                </v-text-field>
                            </div>
                        </div>
                        <div class="col-md-3 align-self-center">
                            <div class="row">
                                <div class="col-6 text-center mb-6">
                                    <v-skeleton-loader
                                        :loading="$store.getters.getTierLoadingStatus"
                                        transition="fade-transition"
                                        height="94"
                                        type="list-item-two-line"
                                    >
                                        <v-tooltip color="primary">
                                            <template v-slot:activator="{ on, attrs }">
                                                <div
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    <span class="info-label d-block mb-1 font-lg">Total Categories</span>
                                                    <span class="info-data p-2">{{ new Intl.NumberFormat().format($store.getters.getCompanyTierStatus.categories) }} / {{ $store.getters.getCompanyTier.categories ? new Intl.NumberFormat().format($store.getters.getCompanyTier.categories) : '∞' }}</span>
                                                </div>
                                            </template>
                                            <span>Total Categories created by your company.</span>
                                        </v-tooltip>
                                    </v-skeleton-loader>
                                </div>
                                <div class="col-6 text-center mb-6">
                                    <v-skeleton-loader
                                        :loading="$store.getters.getTierLoadingStatus"
                                        transition="fade-transition"
                                        height="94"
                                        type="list-item-two-line"
                                    >
                                        <v-tooltip color="primary">
                                            <template v-slot:activator="{ on, attrs }">
                                                <div
                                                    v-bind="attrs"
                                                    v-on="on"
                                                >
                                                    <span class="info-label d-block mb-1 font-lg">Total Brands</span>
                                                    <span class="info-data p-2">{{ new Intl.NumberFormat().format($store.getters.getCompanyTierStatus.brands) }} / {{ $store.getters.getCompanyTier.brands ? new Intl.NumberFormat().format($store.getters.getCompanyTier.brands) : '∞' }}</span>
                                                </div>
                                            </template>
                                            <span>Total Brands created by your company.</span>
                                        </v-tooltip>
                                    </v-skeleton-loader>
                                </div>
                            </div>
                        </div>
                        <div class="col-1 align-self-center">
                            <div class="btn-toolbar float-right" role="toolbar">
                                <button class="btn btn-light" type="button" data-toggle="modal" data-target=".filter-modal"><i class="fas fa-filter"></i></button>
                            </div><!--btn-toolbar-->
                        </div><!--col-->
                    </div>
                    <div class="modal fade filter-modal" tabindex="-1" role="dialog" aria-hidden="true">
                        <div class="modal-dialog modal-lg">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Sort Taxonomies</h5>
                                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div class="modal-body">
                                    <v-row class="mt-2">
                                        <v-col
                                            cols="12"
                                            md="4"
                                        >
                                            <v-select
                                                v-model="searchData.sortBy"
                                                :items="sorts"
                                                label="Sort By"
                                            ></v-select>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="4"
                                        >
                                            <v-select
                                                v-model="searchData.orderBy"
                                                :items="orders"
                                                label="Order By"
                                            ></v-select>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="4"
                                        >
                                            <v-select
                                                v-model="searchData.perPage"
                                                :items="perPage"
                                                label="Per Page"
                                            ></v-select>
                                        </v-col>
                                    </v-row>
                                </div>
                                <div class="modal-footer">
                                    <div class="col-md-2 col-2 px-0 text-right">
                                        <v-progress-circular
                                            v-if="searchData.loading"
                                            :width="2"
                                            :size="30"
                                            indeterminate
                                            color="#fb7e42"
                                            class="mr-2"
                                        ></v-progress-circular>

                                        <button type="button" class="btn btn-light" data-dismiss="modal" aria-label="Close">
                                            <span aria-hidden="true">Close</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <TableLoading cols="5" v-if="loading"></TableLoading>
                    <div class="table-responsive mt-4" v-if="!loading">
                        <table class="table">
                            <thead>
                            <tr>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">ID</span>
                                        </template>
                                        <span>Brand ID</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Brand Name</span>
                                        </template>
                                        <span>Brand Name</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Total POIs</span>
                                        </template>
                                        <span>Total POIs for this Brand</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Category Name</span>
                                        </template>
                                        <span>Category Name</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Updated at</span>
                                        </template>
                                        <span>Brand Updated at</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Created at</span>
                                        </template>
                                        <span>Brand Created at</span>
                                    </v-tooltip>
                                </th>
                                <th>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <span v-on="on">Actions</span>
                                        </template>
                                        <span>Brand Actions</span>
                                    </v-tooltip>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="taxonomy in taxonomies" :key="taxonomy.id" class="taxonomies-row">
                                <td>{{ taxonomy.id || '' }}</td>
                                <td>{{ taxonomy.name || '' }}</td>
                                <td>
                                    <span>{{ new Intl.NumberFormat().format(taxonomy.locations_count) }}</span>
                                    <a @click="redirectToMyPois(taxonomy.id)"><i class="fas fa-link text-info"></i></a>
                                </td>
                                <td>
                                    <span v-if="taxonomy.category">
                                        <span v-if="$store.getters.getCompanyId === (taxonomy.category.companyID)">{{ taxonomy.category.searchName || '' }}</span>
                                        <span v-else><i>{{ taxonomy.category.searchName || '' }}</i></span>
                                    </span>
                                </td>
                                <td>{{ taxonomy.updated_at || '' }}</td>
                                <td>{{ taxonomy.created_at || '' }}</td>
                                <td>
                                    <button class="btn btn-info" v-if="taxonomy.locations_count">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <span v-on="on"><i @click="redirectToLocationsMapPage(taxonomy.id)" class="fas fa-map-marked-alt"></i></span>
                                            </template>
                                            <span>View locations on map</span>
                                        </v-tooltip>
                                    </button>
                                    <button class="btn btn-info" disabled v-else>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <span v-on="on"><i class="fas fa-map-marked-alt"></i></span>
                                            </template>
                                            <span>Locations not available</span>
                                        </v-tooltip>
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                        </table>

                        <v-pagination
                            color="#ff7516"
                            v-if="totalPages > 1"
                            v-model="currentPage"
                            :length="totalPages"
                            :total-visible="7"
                        ></v-pagination>
                    </div>
                </v-app>
            </template>
        </Main>
    </div>
</template>

<script>
import Main from '../../../components/Main'
import api from "../../../api/my-data/poi/submissions";
import mixins from "../../../mixin";
import TableLoading from "../../../components/general/TableLoading";

export default {
    name: "Taxonomies",
    mixins: [mixins],
    data: () => ({
        filter: false,

        searchData: {
            q: '',
            sortBy: 'created_at',
            orderBy: 'desc',
            loading: false,
            perPage: 25,
        },
        currentPage: 1,
        totalPages: 2,

        sorts: [
            {
                value: 'id',
                text: 'ID'
            },
            {
                value: 'name',
                text: 'Brand Name'
            },
            {
                value: 'created_at',
                text: 'Created At'
            },
            {
                value: 'updated_at',
                text: 'Updated At'
            }
        ],

        loading: true,
        deleteModalDialog: false,
        taxonomies: [],
        taxonomy: [],
        deletingTaxonomy: [],
    }),
    components: {
        TableLoading,
        Main,
    },
    methods: {
        async fetchData() {
            await api.getAllTaxonomies({
                page: this.currentPage,
                q: this.searchData.q,
                sortBy: this.searchData.sortBy,
                orderBy: this.searchData.orderBy,
                perPage: this.searchData.perPage,
            })
            .then(res => {
                this.taxonomies = res.data.data
                this.currentPage = res.data.current_page
                this.totalPages = res.data.last_page
                this.loading = false
                this.scrollToTop()
            })
            .catch(e => {
                this.$toast.open({
                    message: e.response.data.message,
                    type: "error",
                })
            })
        },
        filterData: _.debounce(function() {
            this.fetchData()
            this.searchData.loading = false
        }, 800),
        redirectToMyPois(brand) {
            window.location.href = this.my_pois_url + '?brandid=' + brand
        },
        redirectToLocationsMapPage(brand) {
            window.location.href = this.taxonomies_url + '/' + brand + '/map'
        }
    },
    created() {
        this.fetchData()
    },
    watch: {
        currentPage: function () {
            this.fetchData()
        },
        'searchData.q': function () {
            if (this.searchData.q == null) {
                this.searchData.q = ""
            }
            this.filterData()
        },
        'searchData.sortBy': function () {
            this.searchData.loading = true
            this.filterData()
        },
        'searchData.orderBy': function () {
            this.searchData.loading = true
            this.filterData()
        },
        'searchData.perPage': function () {
            this.searchData.loading = true
            this.filterData()
        },
    },
    mounted() {
        this.$store.dispatch('loadUserCompanyTierInfo')
    }
}
</script>

<style scoped lang="scss">
::v-deep .v-application--wrap {
        min-height: fit-content;
    }

button:focus {
    outline:0;
}

.info-data {
    border: 2px solid #fb7e42;
    border-radius: 5px;
    color: #fb7e42;
    font-size: 1.25rem;
    font-weight: bold;
}

.info-label {
    color: #fb7e42;
}

</style>